const fetchCsrfToken = async () => {
  try {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_STAGING_URL}/api/csrf-token`, {
      credentials: 'include', // Ensures cookies are sent
    });

    if (!response.ok) {
      throw new Error('Failed to fetch CSRF token');
    }

    const data = await response.json();
    return data.csrfToken;
  } catch (error) {
    console.error('Error fetching CSRF token:', error.message);
    throw error;
  }
};

export default fetchCsrfToken;

  